module.exports = __webpack_public_path__ + "img/lingdaoricheng.715d2444.png";